
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cartel/[[...slug]]",
      function () {
        return require("private-next-pages/cartel/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cartel/[[...slug]]"])
      });
    }
  